import React, { useState, useEffect, useCallback} from 'react'
/* --------------------------------------------- */
import { useHistory } from 'react-router-dom'
import { setLandingPageRendered } from '../../../utils/sessionStorageService'
/* --------------------------------------------- */

import AssetComponent from "./BottomPageType/AssetComponent"
import Channel from "./BottomPageType/Channel"
import FAQ from "./BottomPageType/FAQ"
import SubscriptionSection from "./BottomPageType/Subscription"

import { ImgContainer, InfoTitleHeader, InfoSubTitleHeader, InfoDescriptionHeader } from './styles'
import "./_landing-page.scss";

/* --------------------------------------------- */
// GenericBottom component for showing pageComponent
const GenericBottom = (props) => {
  // const { graphics } = theme
  // const [theme, updateTheme] = useState(null)
  const { sectionData, contentData, themeSection:theme = {}, channelDataLoaded } = props  
  const {graphics:[imagesData = {}] = [],body = {}} = theme
  const {images:backgroundImages = []} = imagesData
  const {background = {}} = body
  const [bgImage, updatebgImage] = useState(background?.primary || null)
  const history = useHistory()
  // const { appTheme } = useSelector(store => store.themeConfigReducers)

  let contentHeight = 0;
  for (let i = 0; i < contentData.length; i++) {
    const {listData:SubscriptionListData = {}} = contentData[i]
    if (SubscriptionListData && contentHeight < SubscriptionListData?.length) contentHeight = SubscriptionListData.length
  }

  /**
   * It: Updates theme.
   */
  // useEffect(() => {
  //   updateTheme(appTheme)
  // }, [appTheme])

  let resizeWindow = useCallback(() => {
    if (window.innerWidth < 650) {
      updatebgImage(backgroundImages[1]?.url)
    } else if (window.innerWidth > 650) {
      updatebgImage(backgroundImages[0]?.url)
    }
  },[updatebgImage,backgroundImages]);

  useEffect(() => {
    resizeWindow();
    window.addEventListener("resize", resizeWindow);
    return () => window.removeEventListener("resize", resizeWindow);
  }, [resizeWindow]);

  const { subTitle, title, description, sysId } = sectionData || {}

  const genericInfo = (
    <div style={{display: 'flex', flexDirection: 'column', alignItems: 'center'}} id={sysId}>
      {
        subTitle && (
          <InfoSubTitleHeader {...{ theme }} className='infoSection__subtitle'>{subTitle}</InfoSubTitleHeader>
        )
      }
      {
        title && (
          <InfoTitleHeader {...{ theme }} className='infoSection__title'>{title}</InfoTitleHeader>
        )
      }
      {
        description && (
          <InfoDescriptionHeader {...{ theme }} className='infoSection__desc infoSection__label'>{description}</InfoDescriptionHeader>
        )
      }
    </div>
  )

  // const genericAsset = (
  //   <div style={{flex: 0.4, justifyContent: 'center', alignItems: 'center'}}>
  //     <img src={graphics.img} className="generic-asset"/>
  //   </div>
  // )

  const homePageRedirectHandler = () => {
    setLandingPageRendered(true)
    history.push('/')
  }

  return (
    <>
      <ImgContainer style={{backgroundColor:background?.primary}} {...{ images: bgImage }} className="landing-bottom_section">
        {genericInfo}
        {
          sectionData && sectionData.type === 'landing_plan' && <SubscriptionSection sectionData={sectionData} themeSection={theme} contentData={contentData} subScriptionPlanHeight={contentHeight} homePageRedirectHandler={homePageRedirectHandler}/>
        }
        {
          sectionData && sectionData.type === 'landing_content_category' && <AssetComponent sectionData={sectionData} themeSection={theme} contentData={contentData} homePageRedirectHandler={homePageRedirectHandler}/>
        }
        {
          sectionData && sectionData.type === 'landing_channels' && <Channel sectionData={sectionData} themeSection={theme} contentData={contentData} homePageRedirectHandler={homePageRedirectHandler} channelDataLoaded={channelDataLoaded}/>
        }
        {
          sectionData && sectionData.type === 'landing_faq' && <FAQ sectionData={sectionData} themeSection={theme} contentData={contentData} homePageRedirectHandler={homePageRedirectHandler}/>
        }
      </ImgContainer>
    </>
  )
}


/* --------------------------------------------- */
GenericBottom.propTypes = {

}
/* --------------------------------------------- */
GenericBottom.defaultProps = {

}
/* --------------------------------------------- */
export default GenericBottom
